<div class="link-form-container">
  <div class="header-and-form-container">
    <div class="header-container">
      <div class="header-title">
        {{ isUpdate ? "Editar atalho" : "Novo atalho" }}
      </div>
      <div class="header-close" mat-dialog-close>
        <span class="material-icons icon-close"> close </span>
      </div>
    </div>

    <div class="form-container">
      <form [formGroup]="formGroup">
        <div class="select-fields pointer">
          <mat-form-field
            appearance="outline"
            (click)="openList($event, triggerProfile)"
          >
            <mat-label>Perfil de acesso</mat-label>

            <input
              #triggerProfile="matAutocompleteTrigger"
              type="text"
              placeholder="Perfis de acesso"
              aria-label="Perfis de acesso"
              matInput
              formControlName="profiles"
              [matAutocomplete]="autoProfile"
              readonly
            />

            <span matSuffix class="material-icons" *ngIf="!autoProfile.isOpen">
              expand_more
            </span>

            <span matSuffix class="material-icons" *ngIf="autoProfile.isOpen">
              expand_less
            </span>

            <mat-autocomplete #autoProfile="matAutocomplete">
              <mat-option [style.display]="'none'"></mat-option>
              <app-profile-simple-list
                [selectAllText]="selectAll"
                [initialIdProfiles]="idsProfiles"
                (selectEvent)="handleProfilesSelect($event)"
                [hidePhoto]="true"
                [excludeProfiles]="excludeProfiles"
                [hideButtons]="true"
              >
              </app-profile-simple-list>
            </mat-autocomplete>
            <mat-error *ngFor="let validation of validation_messages.profiles">
              <mat-error
                *ngIf="
                  formGroup.get('profiles')?.hasError(validation.type) &&
                  (formGroup.get('profiles')?.dirty ||
                    formGroup.get('profiles')?.touched)
                "
              >
                {{ validation.message }}
              </mat-error>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="select-fields">
          <mat-form-field
            appearance="outline"
            class="pointer-cursor"
            (click)="openList($event, triggerYear)"
          >
            <mat-label>Ano Letivo</mat-label>

            <input
              #triggerYear="matAutocompleteTrigger"
              type="text"
              formControlName="year"
              matInput
              [matAutocomplete]="autoYear"
              readonly
              class="pointer-cursor"
            />

            <mat-autocomplete #autoYear="matAutocomplete" (optionSelected)="changeYear($event.option.value)">
              <mat-option
                *ngFor="let year of years"
                [value]="year"
              >
                {{ year }}
              </mat-option>
            </mat-autocomplete>

            <span matSuffix class="material-icons" *ngIf="!autoYear.isOpen">
              expand_more
            </span>
            <span matSuffix class="material-icons" *ngIf="autoYear.isOpen">
              expand_less
            </span>
          </mat-form-field>
        </div>

        <div class="select-fields classrooms">
          <mat-form-field
            appearance="outline"
            class="pointer-cursor"
            (click)="hasClassrooms && openList($event, triggerClassroom)"
          >
            <mat-label>Turmas</mat-label>

            <input
              label="Turmas"
              placeholder="Turmas"
              #triggerClassroom="matAutocompleteTrigger"
              type="text"
              matInput
              formControlName="classrooms"
              [matAutocomplete]="autoClassroom"
              readonly
              class="pointer-cursor"
            />

            <mat-autocomplete #autoClassroom="matAutocomplete">
              <mat-option [style.display]="'none'"></mat-option>
              <app-select-hierarquical-list
                *ngIf="segmentTreeData.length > 0"
                [treeData]="segmentTreeData"
                [initialSelection]="idsClassrooms"
                (selectEvent)="handleSelectClassroom($event)"
                [hideButtons]="true"
              >
              </app-select-hierarquical-list>
            </mat-autocomplete>

            <mat-error *ngIf="formGroup.get('classrooms')?.hasError('required')">
              Selecione uma Turma
            </mat-error>

            <span
              matSuffix
              class="material-icons"
              *ngIf="hasClassrooms && !autoClassroom.isOpen"
            >
              expand_more
            </span>

            <span matSuffix class="material-icons" *ngIf="hasClassrooms && autoClassroom.isOpen">
              expand_less
            </span>
          </mat-form-field>
        </div>

        <app-attention-alert
          *ngIf="!hasClassrooms"
          [message]="alertMessage"
        >
        </app-attention-alert>

        <div class="select-fields">
          <mat-form-field
            matTooltip="Este é um serviço integrado. O nome não pode ser alterado."
            [matTooltipDisabled]="!integration"
            appearance="outline"
          >
            <mat-label>Nome</mat-label>
            <input
              matInput
              formControlName="name"
              placeholder="Nome"
              [readonly]="integration"
              class="select-field-input"
            />
            <mat-error *ngFor="let validation of validation_messages.name">
              <mat-error
                *ngIf="
                  formGroup.get('name')?.hasError(validation.type) &&
                  (formGroup.get('name')?.dirty ||
                    formGroup.get('name')?.touched)
                "
              >
                {{ validation.message }}
              </mat-error>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="select-fields">
          <mat-form-field
            matTooltip="Este é um serviço integrado. O link não pode ser alterado."
            [matTooltipDisabled]="!integration"
            appearance="outline"
            appearance="outline"
          >
            <mat-label>Link</mat-label>
            <input
              matInput
              formControlName="path"
              placeholder="Link"
              [readonly]="integration"
              class="select-field-input"
            />
            <mat-error *ngFor="let validation of validation_messages.path">
              <mat-error
                *ngIf="
                  formGroup.get('path')?.hasError(validation.type) &&
                  (formGroup.get('path')?.dirty ||
                    formGroup.get('path')?.touched)
                "
              >
                {{ validation.message }}
              </mat-error>
            </mat-error>
          </mat-form-field>
        </div>

        <div>Selecione um ícone</div>

        <mat-button-toggle-group
          matTooltip="Este é um serviço integrado. O ícone não pode ser alterado."
          [matTooltipDisabled]="!integration"
          [disabled]="integration"
          class="icon-list"
        >
          <div *ngFor="let icon of materialIcons">
            <mat-button-toggle
              #iconButton
              value="icon.iconWebName"
              (click)="iconButtonToggleClicked(icon)"
              [checked]="icon.checked"
            >
              <app-icon
                [iconName]="icon.iconWebName"
                [checked]="iconButton.checked"
              >
              </app-icon>
            </mat-button-toggle>
          </div>
        </mat-button-toggle-group>
      </form>
    </div>
  </div>

  <div class="footer-container">
    <button mat-raised-button class="btn-cancel" mat-dialog-close>
      Cancelar
    </button>
    <div class="divider"></div>
    <button
      mat-raised-button
      mat-dialog-close
      class="btn-save"
      [disabled]="!canSave() || !hasClassrooms"
      (click)="saveLink()"
    >
      {{ isUpdate ? "Alterar" : "Adicionar" }}
    </button>
  </div>
</div>
